export default __webpack_public_path__ + "//i/components/system-notification/images//session-expired-img.png";